// export DsfSelect from "./select";
// export DsfCascader from "./cascader";
// export DsfRadioBox from "./radioBox";
// export DsfCheckBox from './checkBox';
// export DsfOuaSelect from './ouaSelect';
// export DsfAreaSelect from './areaSelect';
// export DsfDataChoice from './dataChoice';
// export DsfSwitch from './switch';
// export DsfSignature from './signature';
// export DsfTag from './tag';
// export DsfAreaSelectDialog from './areaSelectDialog';
// export DsfEncryptLevel from "./encryptLevel.vue"

export DsfSelect from "./select";
export DsfRadioBox from "./radioBox";
export DsfCheckBox from "./checkBox";

export const DsfDataChoice = dsf.defineLazyComponent("DsfDataChoice", () => require("./dataChoice"));
export const DsfCascader = dsf.defineLazyComponent("DsfCascader", () => require("./cascader"));
export const DsfAreaSelect = dsf.defineAsyncComponent("DsfAreaSelect", () => import(/*webpackChunkName:"platform_form"*/ "./areaSelect"));
export const DsfOuaSelect = dsf.defineAsyncComponent("DsfOuaSelect", () => import(/*webpackChunkName:"platform_form"*/ "./ouaSelect"));
export const DsfSwitch = dsf.defineAsyncComponent("DsfSwitch", () => import(/*webpackChunkName:"platform_form"*/ "./switch"));
export const DsfTag = dsf.defineAsyncComponent("DsfTag", () => import(/*webpackChunkName:"platform_form"*/ "./tag"));
export const DsfSignature = dsf.defineAsyncComponent("DsfSignature", () => import(/*webpackChunkName:"platform_form"*/ "./signature.vue"));
export const DsfAreaSelectDialog = dsf.defineAsyncComponent("DsfAreaSelectDialog", () => import(/*webpackChunkName:"platform_form"*/ "./areaSelectDialog.vue"));

export const DsfEncryptLevel = dsf.defineAsyncComponent("DsfEncryptLevel", () => import(/*webpackChunkName:"platform_form"*/ "./encryptLevel.vue"));
